import { api } from './client'
import type { ApiPage } from '@fcms/ui'
import type { Announcement } from './types'

export function listAnnouncements(params: {
  cursor?: string | null
  limit?: number
  signal?: AbortSignal
}): Promise<ApiPage<Announcement>> {
  const { signal, ...query } = params
  return api.requestPage<Announcement>('/announcements', { query, signal })
}

export async function markAnnouncementRead(id: string): Promise<void> {
  await api.post(`/announcements/${id}/read`)
}
